import { useCallback } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

export type OKRGroupByViewType = 'INDIVIDUAL' | 'OBJECTIVE';

export const useOKRGroupByViewType = () => {
  const location = useLocation();
  const { search } = location;
  const history = useHistory();
  const viewTypeFromParam = new URLSearchParams(search).get('groupByViewType') as OKRGroupByViewType;

  const setGroupByViewType = useCallback(
    (viewType: OKRGroupByViewType) => {
      const queryParams = new URLSearchParams(search);
      queryParams.set('groupByViewType', viewType);
      if (viewType === 'INDIVIDUAL') {
        queryParams.set('manageViewType', 'list');
      }
      history.push({
        search: queryParams.toString(),
      });
    },
    [history, search]
  );

  const replaceGroupByViewType = useCallback(
    (viewType: OKRGroupByViewType) => {
      const queryParams = new URLSearchParams(search);
      queryParams.set('groupByViewType', viewType);
      if (viewType === 'INDIVIDUAL') {
        queryParams.set('manageViewType', 'list');
      }
      history.replace({
        search: queryParams.toString(),
      });
    },
    [history, search]
  );

  return {
    groupByViewType: viewTypeFromParam,
    setGroupByViewType,
    replaceGroupByViewType,
  };
};
